
import request from "./request";

export default async function getIncome(params = {}) {
  return await request.get("/spin/dataBusiness/getIncome", {
    params,
  });
}